import React from 'react';

const GoogleReviews: React.FC = () => {
  return (
    <div className="hidden">
      {/* 该组件内容已移至Testimonials组件 */}
    </div>
  );
};

export default GoogleReviews;
